import React, { Fragment } from 'react';
import  EirPrequalForm  from '../eir-prequal-container/EirPrequalForm';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from '../../styles/theme';



export default function EirOrderContainer(props) {
   return(
       <Fragment>
            <ThemeProvider theme={theme}>
            <EirPrequalForm></EirPrequalForm>
            </ThemeProvider>
        </Fragment>
    );
}
